import { MouseEvent } from 'react';
import { ROUTES } from '../../Base.constants';
import { CheckArticleAccessStatus } from '../../hooks/articles/useCheckArticleAccessStatus';
import { isLeftMouseButtonEvent } from '../../utils/inputEventUtils';
import { openWindowInNewTab, shouldNavigate, shouldOpenInNewTab } from '../../utils/navigationUtils';

export const ARTICLE_PREVIEW_ID = 'article-preview';

export const ArticlePreviewWidthKey = 'articlePreviewWidth';

export const OpenArticlePreviewOnClickKey = 'openArticlePreviewOnClick';

export const getArticleDataTestId = (dataTestId: string, isArticlePreview: boolean): string =>
  isArticlePreview ? `preview-${dataTestId}` : dataTestId;

export interface PreviewArticle {
  id: number;
}

export const getArticlePreviewHandler =
  (
    setPreviewArticleId: (articleId: number) => void,
    isDesktop: boolean,
    navigate: (route: string) => void,
    checkArticleAccessStatus: CheckArticleAccessStatus,
    openArticlePreviewOnClick?: boolean,
    isCompact?: boolean
  ): ((article: PreviewArticle, e: MouseEvent) => void) =>
  (article: PreviewArticle, e: MouseEvent) => {
    const isOpenInNewTab = shouldOpenInNewTab(e);
    const isOpenInSameTab = shouldNavigate(isDesktop, openArticlePreviewOnClick, isCompact);
    const isOpenInArticlePreview = isLeftMouseButtonEvent(e) || openArticlePreviewOnClick;
    if (isOpenInNewTab) {
      openWindowInNewTab(ROUTES.article(article.id));
    } else if (isOpenInSameTab) {
      navigate(ROUTES.article(article.id));
    } else if (isOpenInArticlePreview) {
      checkArticleAccessStatus(article.id, () => {
        setPreviewArticleId(article.id);
        document.getElementById(ARTICLE_PREVIEW_ID)?.scroll({ top: 0 });
      });
    }
  };
